export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0B0F17" />
    <rect x="1" y="1" width="62" height="62" rx="13" fill="none" stroke="#10B981" strokeOpacity="0.45" strokeWidth="2" />
    <path d="M38 9 L17 37 h11 L25 55 L47 26 H36 L38 9 Z" fill="#10B981" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="evgp-logo">
    <LogoMark className="h-10 w-10 shrink-0" />
    <span className="flex flex-col leading-none">
      <span className="font-display text-2xl font-bold uppercase tracking-wider text-vg-white">
        EVGP<span className="text-vg-green">·</span>Italia
      </span>
      {!compact && (
        <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.32em] text-vg-muted">
          2027 · Misano
        </span>
      )}
    </span>
  </span>
);
